import {DirectiveOptions} from 'vue'
import {convertTelNumberFromDirective} from '@/helpers'

const convertTelNumberDirective: DirectiveOptions = {
  bind: function (el: any, binding, vNode) {
    el.val = binding.value
    el.handler = (e) => {
      const v = el.val
      if (v && v !== '') {
        e.target.value = convertTelNumberFromDirective(v)
        vNode.elm.dispatchEvent(new CustomEvent('input'))
      }
    }
    el.addEventListener('change', el.handler)
  },
  update(el: any, binding, vNode) {
    el.val = binding.value
  },
  unbind: function (el: any) {
    el.removeEventListener('change', el.handler)
  }
}

export default convertTelNumberDirective
